'use strict';

/**
 * @ngdoc service
 * @name prepApp.ConfigService
 * @description
 * # ConfigService
 * Service in the prepApp.
 */
angular.module('prepApp')
    .service('ConfigService', function (NgTableParams, TASK_TYPE, CONFIG) {
        return {
            NgTableParams: NgTableParams,
            TASK_TYPE: TASK_TYPE,
            CONFIG: CONFIG
        };
    });
